//@ts-nocheck
import React, { useEffect, useMemo, useState } from "react";
import {
    Box,
    FormControl,
    useMediaQuery,
    useTheme,
    Autocomplete,
    TextField,
    Typography
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { Stack } from "@mui/system";
import { Button, Loading } from "../../atoms";
import { InputControl, SelectControl, SwitchControl } from "../../molecules";
import { useLocation, useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";

import {
    useGetCommissionProfileList,
    useGetInstallmentCountSettingsList,
    useGetAllMerchantList,
    useGetAcquirerBankList,
    useGetPayment3DTrxSettingsList,
    useUpdateCommissionParameter,
    useAuthorization,
    useGetMemberVPosList,
    useGetCardBrandsList,
    PagingResponse,
    useGetAllSectors,
    useGetSectorMapping,
    usePostUpdateSectorInstallmentMapping,
    useGetMemberVposBankList
} from "../../../hooks";
import { sectorAddFormSchema, sectorAddFormSchemaFormValuesType, sectorAddInitialValues } from "./_formTypes";

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

import {
    GridColDef,
    GridRowId,
    GridRenderCellParams,
    GridActionsCellItem,
    GridValueFormatterParams,
    GridPaginationModel,
} from "@mui/x-data-grid";
import { Table, DeleteConfirmModal } from "../../molecules";
import { Label } from "@mui/icons-material";

import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const FloatingActionButton = ({ onClick }) => {
    const buttonStyle = {
        position: 'fixed',
        bottom: '16px',
        right: '16px',
        backgroundColor: '#3f51b5',
        color: '#fff',
        fontWeight: 'bold',
        margin: '10px',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    };

    return (
        <Fab
            style={buttonStyle}
            variant="extended"
            aria-label="add"
            onClick={() => onClick()}
        >
            Güncelle
        </Fab>
    );
};

export const SectorMappingInstallmentMappingManagementForm = () => {

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const setSnackbar = useSetSnackBar();

    const { data: rawAcquirerBankList, refetch } = useGetMemberVposBankList();
    const { mutate: getSectors, isLoading: isSectorsLoading } = useGetAllSectors();
    const { mutate: getMapping, isLoading: isSectorInstallmentMappingLoading } = useGetSectorMapping();
    const { mutate: updateSectorInstallmentMapping, isLoading: isUpdateSectorInstallmentMappingLoading } = usePostUpdateSectorInstallmentMapping();

    const [sectors, setSectors] = useState(null);
    const [selectedSector, setSelectedSector] = useState(null);
    const [bankMappings, setBankMappings] = useState([]);
    const [installmentCounts, setInstallmentCounts] = useState({});

    const groupedBankList = useMemo(() => {
        const grouped = rawAcquirerBankList?.data?.reduce((acc, bank) => {
            if (!acc[bank.bankCode]) {
                acc[bank.bankCode] = [];
            }
            acc[bank.bankCode].push(bank);
            return acc;
        }, {});

        var returnOBJ = Object.keys(grouped || {}).map((code) => ({
            bankCode: grouped[code][0].bankCode,
            bankName: grouped[code][0].bankName
        }));

        return returnOBJ;
    }, [rawAcquirerBankList?.data]);

    useEffect(() => {
        if (sectors == null && isSectorsLoading === false) {
            getSectors({
                page: 1,
                size: 9999,
                orderByDesc: true,
                // status: 'ACTIVE'
            }, {
                onSuccess: (data) => {
                    setSectors(data.data.result);
                },
                onError: (error) => {
                },
            })
        }
    }, [isSectorsLoading]);

    const handleSectorChange = async (event, newValue) => {
        setSelectedSector(newValue);
        setInstallmentCounts({}); // Reset counts when sector changes
        if (newValue) {
            getMapping(newValue.id, {
                onSuccess: (data) => {
                    setBankMappings(data.data);
                    // Initialize installmentCounts with mapping values
                    const initialCounts = {};
                    data.data.forEach(mapping => {
                        initialCounts[mapping.bankCode] = mapping.maxInstallmentCount;
                    });
                    setInstallmentCounts(initialCounts);
                }
            });
        } else {
            setBankMappings([]);
        }
    };

    const handleInstallmentChange = (bankId, value) => {
        setInstallmentCounts(prev => {
            if (value === '') {
                const newState = { ...prev };
                delete newState[bankId];
                return newState;
            }
            return {
                ...prev,
                [bankId]: value
            };
        });
    };

    const handleSectorInstallmentUpdate = () => {
        const installmentData = Object.entries(installmentCounts).map(([bankCode, maxInstallmentCount], index) => ({
            sectorId: selectedSector.id,
            bankCode: bankCode,
            maxInstallmentCount: maxInstallmentCount
        }));

        updateSectorInstallmentMapping({
            sectorId: selectedSector.id,
            list: installmentData
        }, {
            onSuccess: (data) => {
                setSnackbar({
                    description: 'Sektör taksit bilgileri güncellendi',
                    severity: 'success',
                    isOpen: true
                });
            },
            onError: (error) => {
                setSnackbar({
                    description: 'Sektör taksit bilgileri güncellenirken bir hata oluştu',
                    severity: 'error',
                    isOpen: true
                });
            }
        });
    }

    return (
        <Stack sx={{ display: 'flex' }}>
            <Box sx={{ width: '100%', bgcolor: 'background.paper', padding: 2, borderRadius: 2, boxShadow: 2 }}>
                {isSectorsLoading && <Loading />}

                <Autocomplete
                    options={sectors}
                    getOptionLabel={(option) => option.sectorName}
                    onChange={handleSectorChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Sektör"
                            variant="outlined"
                            fullWidth
                            sx={{ mb: 3 }}
                        />
                    )}
                />

                {rawAcquirerBankList && (
                    <Box sx={{ mt: 2 }}>
                        {groupedBankList?.map((bank) => {
                            const mapping = bankMappings.find((m) => m.bankCode === bank.bankCode);
                            return (
                                <Box
                                    key={bank.bankCode}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        my: .5,
                                        p: 1,
                                        borderRadius: 1,
                                        border: 1,
                                        borderColor: 'grey.100',
                                    }}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{ minWidth: '200px', fontWeight: 500 }}
                                    >
                                        {bank.bankName}
                                    </Typography>
                                    <TextField
                                        type="number"
                                        value={installmentCounts[bank.bankCode] || ''}
                                        onChange={(e) => {
                                            const value = e.target.value === '' ? '' : Number(e.target.value);
                                            if (value === '' || (value >= 1 && value <= 12)) {
                                                handleInstallmentChange(bank.bankCode, value);
                                            }
                                        }}
                                        sx={{ width: '150px' }}
                                        disabled={!selectedSector}
                                        inputProps={{
                                            min: 1,
                                            max: 12, // Limits input values to a maximum of 12
                                            inputMode: 'numeric',
                                            pattern: '[1-9]|1[0-2]', // Regular expression for values 1-12
                                        }}
                                        variant="outlined"
                                    />
                                </Box>
                            );
                        })}
                    </Box>
                )}

                <FloatingActionButton
                    onClick={handleSectorInstallmentUpdate}
                    sx={{
                        position: 'fixed',
                        bottom: 16,
                        right: 16,
                        bgcolor: 'primary.main',
                        color: 'white',
                        ':hover': { bgcolor: 'primary.dark' },
                    }}
                />
            </Box>
        </Stack>
    );
};